import { CheckOutlined, CloseOutlined, LoadingOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { TextField } from '@mui/material';
import { Col, Row, Spin, message } from 'antd';
import { useState } from 'react';
import { getStripePaymentURL } from '../PaymentLambdaUtils';
import { CardDetails } from '../PaymentManagerType';

interface PaymentDetailsPropsProps {
    cardDetails: CardDetails | null;
    loadingRate: boolean;
}

const PaymentMethodDetails: React.FC<PaymentDetailsPropsProps> = ({ cardDetails, loadingRate }) => {
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);

    const handlePayment = () => {
        setButtonLoading(true)
        getStripePaymentURL()
            .then((resp: string) => {
                const data = JSON.parse(resp);
                if (data.checkout_url) {
                    window.location.href = data.checkout_url; // Redirect to the URL
                } else {
                    message.error("URL not found");
                }
            })
            .catch((err) => {
                message.error("Failed to fetch stripe url");
                console.log(err);
            })
            .finally(() => {
                setButtonLoading(false);
            });
    }

    return (
        <div className='payment_method_block'>
            <div className='payment_method_link_box'>
                <span className={`payment_method_Add_link ${buttonLoading ? 'loading' : ''}`}
                    onClick={buttonLoading ? undefined : handlePayment}
                    style={{
                        pointerEvents: buttonLoading ? 'none' : 'auto',
                        cursor: buttonLoading ? 'not-allowed' : 'pointer'
                    }}>
                    <p className='payment_method_link_text'>
                        {buttonLoading ? <LoadingOutlined /> : <PlusCircleOutlined />} Add / Update Payment Method
                    </p>
                </span>
            </div>
            <>
                <p className='price_detail_title'>Payment Method</p>
                <Spin spinning={loadingRate}>
                    <div className='panel_data_form card_details_block'>
                        {cardDetails && (
                            <>
                                <Row className='panel_row' justify="center">
                                    <Col xs={24} sm={12} md={12} className="card_column_left">
                                        <TextField
                                            label="Card No."
                                            value={cardDetails?.last4}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            aria-readonly
                                        />
                                    </Col>
                                    <Col xs={24} sm={12} md={12} className="card_column_right">
                                        <TextField
                                            label="Expiry Date"
                                            value={cardDetails?.exp_date}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            aria-readonly
                                        />
                                    </Col>
                                </Row>
                                <Row className='panel_row' justify="center">
                                    <Col xs={24} sm={12} md={12} className="card_column_left">
                                        <TextField
                                            label="Brand"
                                            value={cardDetails?.brand}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            aria-readonly
                                        />
                                    </Col>
                                    <Col xs={24} sm={12} md={12} className="card_column_right right-block">

                                    </Col>
                                </Row>
                                <div className='card_inner_flex_main'>
                                    {(cardDetails?.test_mode !== undefined && cardDetails?.test_mode !== null) || (cardDetails?.active !== undefined && cardDetails?.active !== null) &&
                                        <label className='card_inner_title'>Notes : </label>
                                    }
                                    {cardDetails?.test_mode !== undefined && cardDetails?.test_mode !== null && (
                                        <div className='card_inner_flex'>
                                            <label>Test Mode: </label>
                                            <div>
                                                {cardDetails?.test_mode ? (
                                                    <CheckOutlined style={{ color: 'green', display: "flex" }} />
                                                ) : (
                                                    <CloseOutlined style={{ color: 'red', display: "flex" }} />
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {cardDetails?.active !== undefined && cardDetails?.active !== null && (
                                        <div className='card_inner_flex'>
                                            <label>Active : </label>
                                            <div>
                                                {cardDetails?.active ? (
                                                    <CheckOutlined style={{ color: 'green', display: "flex" }} />
                                                ) : (
                                                    <CloseOutlined style={{ color: 'red', display: "flex" }} />
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </Spin>
            </>
        </div>
    );
}

export default PaymentMethodDetails;
